/* eslint-disable */
export default {
  forward: 'Desviar',
  ignore: 'Ignorar',
  toVoicemail: 'Al buzón de voz',
  answer: 'Responder',
  endAndAnswer: 'Finalizar y responder',
  holdAndAnswer: 'En espera y responder',
  custom: 'Personalizado',
  more: 'Más',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
